import Vue from "vue";
import Router from "vue-router";
/* Layout */
import Layout from "./views/layout/Layout";
Vue.use(Router);
import {
  Message
} from "element-ui";
import {
  isAlipay,
  isWeixn,
  parseQueryString
} from "./utils";

export const constantRouterMap = [{
  path: "/",
  component: Layout,
  redirect: "/home",
  children: [{
    path: "home",
    component: () => import("@/views/mobileBookActivity"),
    meta: {
      title: '聚创教育集团'
    }
  }],
  hidden: true
},
{
  path: "/dingpreIndex",
  component: () => import("@/views/dingpreIndex"),
  hidden: true
},
{
  path: "/teacherLogin",
  component: () => import("@/views/teacherLogin"),
  hidden: true
},
{
  path: "/classRegistration",
  component: () => import("@/views/classRegistration"),
  hidden: true,
  meta: {
    title: "课程登记"
  }
},
{
  path: "/confirmAddress",
  component: () => import("@/views/confirmAddress"),
  hidden: true,
  meta: {
    title: "收货地址确认"
  }
},
{
  path: "/classRegistration/confirm",
  component: () => import("@/views/classRegistration/confirm"),
  hidden: true,
  meta: {
    title: "信息确认"
  }
},
{
  path: "/classRegistration/result",
  component: () => import("@/views/classRegistration/result"),
  hidden: true,
  meta: {
    title: "登记结果"
  }
},
{
  path: "/classRegistration/collectionList",
  component: () => import("@/views/classRegistration/collectionList"),
  hidden: true,
  meta: {
    title: "选择课程"
  }
},
{
  path: "/404",
  component: () => import("@/views/404"),
  meta: {
    title: '404'
  },
  hidden: true
},
//中转站
{
  path: "/t",
  component: () => import("@/views/transfer"),
  hidden: true
},
//大促会中转站
{
  path: "/td",
  component: () => import("@/views/transferInd"),
  hidden: true
},
// 大促会表单
{
  path: "/industrial",
  component: () => import("@/views/industrial"),
  hidden: true
},
//应聘路由
{
  path: "/interviewRegister",
  component: () => import("@/views/mobileInterviewRegister"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
//法大大合同签署成功后提示页面
{
  path: "/contractSignSucc",
  component: () => import("@/views/contractSignSucc"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
// 赠书活动
{
  path: "/activityWriteInfo",
  component: () => import("@/views/mobileBookActivity"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
// 问卷调查
{
  path: "/mobileQuestions",
  component: () => import("@/views/mobileQuestions"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
// 新版问卷调查
{
  path: "/mobileQuestionsSuccess",
  component: () => import("@/views/mobileQuestionsNew/success"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
{
  path: "/mobileQuestionsNew",
  component: () => import("@/views/mobileQuestionsNew"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
// 新版问卷调查扥登录
{
  path: "/mobileQuestionsNewLogin",
  component: () => import("@/views/mobileQuestionsNew/login"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
// 宏医教育隐私政策
{
  path: "/privacyPolicy",
  component: () => import("@/views/privacyPolicy"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
// 隐私政策-2023版本
{
  path: "/privacyPolicy_2023",
  component: () => import("@/views/privacyPolicy_2023"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
// 电子收据
{
  path: "/electronicReceipt",
  component: () => import("@/views/electronicReceipt"),
  name: "electronicReceipt",
  meta: {
    title: '电子收据'
  },
  hidden: true
},
// 住宿收款-电子收据
{
  path: "/stayElectronicReceipt",
  component: () => import("@/views/stayElectronicReceipt"),
  name: "stayElectronicReceipt",
  meta: {
    title: '电子收据'
  },
  hidden: true
},
// 图书订单 -电子收据
{
  path: "/booksElectronicReceipt",
  component: () => import("@/views/booksElectronicReceipt"),
  name: "booksElectronicReceipt",
  meta: {
    title: '电子收据'
  },
  hidden: true
},
{
  path: "/autoLogin",
  component: () => import("@/views/autoLogin"),
  meta: {
    title: '自动登录'
  },
  hidden: true
},
// 权限验证
{
  path: "/roleCheck",
  component: () => import("@/views/roleCheck"),
  meta: {
    title: '授权登录'
  },
  hidden: true
},
// 地址收集登录
{
  path: "/addressCheck",
  component: () => import("@/views/roleCheck"),
  meta: {
    title: '授权登录'
  },
  hidden: true
},
// 代理授权登录
{
  path: "/agent",
  component: () => import("@/views/agent"),
  meta: {
    title: '授权登录'
  },
  hidden: true
},
// 研究生授权登录
{
  path: "/graduateStudent",
  component: () => import("@/views/graduateStudent"),
  meta: {
    title: '授权登录'
  },
  hidden: true
},

// 院校确认授权登录
{
  path: "/collegeConfirmation",
  component: () => import("@/views/collegeConfirmation"),
  meta: {
    title: '授权登录'
  },
  hidden: true
},

// 信息确认
{
  path: "/infoConfirm",
  component: () => import("@/views/infoConfirm"),
  meta: {
    title: '信息确认'
  },
  hidden: true
},
// 富有跳转-中转站
{
  path: "/transitStation",
  component: () => import("@/views/transitStation"),
  meta: {
    title: '跳转中'
  },
  hidden: true
},
// 找人帮付
{
  path: "/findHelp",
  component: () => import("@/views/findHelp"),
  meta: {
    title: '找人帮付'
  },
  hidden: true
},
// 收款码展示
{
  path: "/makeCode",
  meta: {
    title: '收款码'
  },
  component: () => import("@/views/makeCode"),
  hidden: true
},
// 收款码展示1
{
  path: "/paymentCode",
  meta: {
    title: '收款码'
  },
  component: () => import("@/views/paymentCode"),
  hidden: true
},
// 基本信息
{
  path: "/basicInfo",
  meta: {
    title: '基本信息'
  },
  component: () => import("@/views/basicInfo"),
  hidden: true
},
// 我的订单
{
  path: "/myOrder",
  meta: {
    title: '我的订单'
  },
  component: () => import("@/views/myOrder"),
  hidden: true
},
// 我的合同
{
  path: "/myContract",
  meta: {
    title: '我的合同'
  },
  component: () => import("@/views/myContract"),
  hidden: true
},
// 空订单
{
  path: "/orderNull",
  component: () => import("@/views/orderNull"),
  hidden: true
},
// 住宿收款码-信息确认
{
  path: "/stayPayConfirm",
  meta: {
    title: '信息确认',
    keepAlive: true
  },
  component: () => import("@/views/stayPayConfirm"),
  hidden: true
},
// 住宿收款码-订单详情
{
  path: "/orderDetails",
  meta: {
    title: '订单详情'
  },
  component: () => import("@/views/orderDetails"),
  hidden: true
},
// 图书订单-订单详情
{
  path: "/booksDetails",
  meta: {
    title: '订单详情'
  },
  component: () => import("@/views/booksDetails"),
  hidden: true
},
// 图书订单-信息确认
{
  path: "/booksConfirm",
  meta: {
    title: '信息确认',
    keepAlive: true
  },
  component: () => import("@/views/booksConfirm"),
  hidden: true
},
// 提前下单订单确认
{
  path: "/aheadInfo",
  component: () => import("@/views/aheadInfo"),
  hidden: true,
  meta: {
    title: '信息确认'
  }
},
// 去付款
{
  path: "/payment",
  component: () => import("@/views/payment"),
  hidden: true,
  meta: {
    title: '去付款'
  },
},
// 交易结果
{
  path: "/payResult",
  name: "payResult",
  component: () => import("@/views/payResult"),
  hidden: true,
  meta: {
    title: '交易结果'
  }
},
// 在线支付/线下支付信息确认
{
  path: "/payInfoConfirm",
  component: () => import("@/views/payInfoConfirm"),
  hidden: true,
  meta: {
    title: '信息确认'
  }
},
// 支付等待
{
  path: "/payLoading",
  component: () => import("@/views/payLoading"),
  hidden: true,
  meta: {
    title: "微信"
  }
},
// 完善信息成功
{
  path: "/infoSuccess",
  component: () => import("@/views/infoSuccess"),
  hidden: true,
  meta: {
    title: "完善信息"
  }
},

// 添加代理信息
{
  path: "/addProxyInfo",
  component: () => import("@/views/addProxyInfo"),
  hidden: true,
  meta: {
    title: "填写信息"
  }
},

// 除了支付页面，第二个公共登录页 使用type区分跳转页面，以及功能点
{
  path: "/dingpreIndex",
  component: () => import("@/views/dingpreIndex"),
  hidden: true
},
{
  path: "/teacherLogin",
  component: () => import("@/views/teacherLogin"),
  hidden: true
},
{
  path: "/classRegistration",
  component: () => import("@/views/classRegistration"),
  hidden: true,
  meta: {
    title: "课程登记"
  }
},
{
  path: "/confirmAddress",
  component: () => import("@/views/confirmAddress"),
  hidden: true,
  meta: {
    title: "收货地址确认"
  }
},
{
  path: "/classRegistration/confirm",
  component: () => import("@/views/classRegistration/confirm"),
  hidden: true,
  meta: {
    title: "信息确认"
  }
},
{
  path: "/classRegistration/result",
  component: () => import("@/views/classRegistration/result"),
  hidden: true,
  meta: {
    title: "登记结果"
  }
},
{
  path: "/classRegistration/collectionList",
  component: () => import("@/views/classRegistration/collectionList"),
  hidden: true,
  meta: {
    title: "选择课程"
  }
},
{
  path: "/learningCamp",
  component: () => import("@/views/learningCamp/index"),
  hidden: true,
  meta: {
    title: "集训营登录"
  }
},
{
  path: "/learningCampRegister",
  component: () => import("@/views/learningCamp/learningCampRegister/index"),
  hidden: true,
  meta: {
    title: "入营登记"
  }
},
{
  path: "/learningCamp/campRoomInfo",
  component: () => import("@/views/learningCamp/CampRoomInfo/index"),
  hidden: true,
  meta: {
    title: "宿舍信息"
  }
},
// {
//   path: "/learningCamp/levelRoom",
//   component: () => import("@/views/learningCamp/LevelRoom/index"),
//   hidden: true,
//   meta: {
//     title: "宿舍信息"
//   }
// },
{
  path: "/learningCamp/levelRoom",
  component: () => import("@/views/learningCamp/LevelRoom/index"),
  hidden: true,
  meta: {
    title: "离营登记"
  }
},
{
  path: "/404",
  component: () => import("@/views/404"),
  meta: {
    title: '404'
  },
  hidden: true
},
//中转站
{
  path: "/t",
  component: () => import("@/views/transfer"),
  hidden: true
},
//大促会中转站
{
  path: "/td",
  component: () => import("@/views/transferInd"),
  hidden: true
},
// 大促会表单
{
  path: "/industrial",
  component: () => import("@/views/industrial"),
  hidden: true
},
//应聘路由
{
  path: "/interviewRegister",
  component: () => import("@/views/mobileInterviewRegister"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
//法大大合同签署成功后提示页面
{
  path: "/contractSignSucc",
  component: () => import("@/views/contractSignSucc"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
// 赠书活动
{
  path: "/activityWriteInfo",
  component: () => import("@/views/mobileBookActivity"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
// 问卷调查
{
  path: "/mobileQuestions",
  component: () => import("@/views/mobileQuestions"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
// 新版问卷调查
{
  path: "/mobileQuestionsSuccess",
  component: () => import("@/views/mobileQuestionsNew/success"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
{
  path: "/mobileQuestionsNew",
  component: () => import("@/views/mobileQuestionsNew"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
// 新版问卷调查扥登录
{
  path: "/mobileQuestionsNewLogin",
  component: () => import("@/views/mobileQuestionsNew/login"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
// 宏医教育隐私政策
{
  path: "/privacyPolicy",
  component: () => import("@/views/privacyPolicy"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
// 隐私政策-2023版本
{
  path: "/privacyPolicy_2023",
  component: () => import("@/views/privacyPolicy_2023"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},
// 电子收据
{
  path: "/electronicReceipt",
  component: () => import("@/views/electronicReceipt"),
  name: "electronicReceipt",
  meta: {
    title: '电子收据'
  },
  hidden: true
},
// 住宿收款-电子收据
{
  path: "/stayElectronicReceipt",
  component: () => import("@/views/stayElectronicReceipt"),
  name: "stayElectronicReceipt",
  meta: {
    title: '电子收据'
  },
  hidden: true
},
// 图书订单 -电子收据
{
  path: "/booksElectronicReceipt",
  component: () => import("@/views/booksElectronicReceipt"),
  name: "booksElectronicReceipt",
  meta: {
    title: '电子收据'
  },
  hidden: true
},
{
  path: "/autoLogin",
  component: () => import("@/views/autoLogin"),
  meta: {
    title: '自动登录'
  },
  hidden: true
},
// 权限验证
{
  path: "/roleCheck",
  component: () => import("@/views/roleCheck"),
  meta: {
    title: '授权登录'
  },
  hidden: true
},
// 地址收集登录
{
  path: "/addressCheck",
  component: () => import("@/views/roleCheck"),
  meta: {
    title: '授权登录'
  },
  hidden: true
},
// 代理授权登录
{
  path: "/agent",
  component: () => import("@/views/agent"),
  meta: {
    title: '授权登录'
  },
  hidden: true
},
// 研究生授权登录
{
  path: "/graduateStudent",
  component: () => import("@/views/graduateStudent"),
  meta: {
    title: '授权登录'
  },
  hidden: true
},

// 院校确认授权登录
{
  path: "/collegeConfirmation",
  component: () => import("@/views/collegeConfirmation"),
  meta: {
    title: '授权登录'
  },
  hidden: true
},

// 信息确认
{
  path: "/infoConfirm",
  component: () => import("@/views/infoConfirm"),
  meta: {
    title: '信息确认'
  },
  hidden: true
},
// 富有跳转-中转站
{
  path: "/transitStation",
  component: () => import("@/views/transitStation"),
  meta: {
    title: '跳转中'
  },
  hidden: true
},
// 找人帮付
{
  path: "/findHelp",
  component: () => import("@/views/findHelp"),
  meta: {
    title: '找人帮付'
  },
  hidden: true
},
// 收款码展示
{
  path: "/makeCode",
  meta: {
    title: '收款码'
  },
  component: () => import("@/views/makeCode"),
  hidden: true
},
// 收款码展示1
{
  path: "/paymentCode",
  meta: {
    title: '收款码'
  },
  component: () => import("@/views/paymentCode"),
  hidden: true
},
// 基本信息
{
  path: "/basicInfo",
  meta: {
    title: '基本信息'
  },
  component: () => import("@/views/basicInfo"),
  hidden: true
},
// 我的订单
{
  path: "/myOrder",
  meta: {
    title: '我的订单'
  },
  component: () => import("@/views/myOrder"),
  hidden: true
},
// 我的合同
{
  path: "/myContract",
  meta: {
    title: '我的合同'
  },
  component: () => import("@/views/myContract"),
  hidden: true
},
// 空订单
{
  path: "/orderNull",
  component: () => import("@/views/orderNull"),
  hidden: true
},
// 住宿收款码-信息确认
{
  path: "/stayPayConfirm",
  meta: {
    title: '信息确认',
    keepAlive: true
  },
  component: () => import("@/views/stayPayConfirm"),
  hidden: true
},
// 住宿收款码-订单详情
{
  path: "/orderDetails",
  meta: {
    title: '订单详情'
  },
  component: () => import("@/views/orderDetails"),
  hidden: true
},
// 图书订单-订单详情
{
  path: "/booksDetails",
  meta: {
    title: '订单详情'
  },
  component: () => import("@/views/booksDetails"),
  hidden: true
},
// 图书订单-信息确认
{
  path: "/booksConfirm",
  meta: {
    title: '信息确认',
    keepAlive: true
  },
  component: () => import("@/views/booksConfirm"),
  hidden: true
},
// 提前下单订单确认
{
  path: "/aheadInfo",
  component: () => import("@/views/aheadInfo"),
  hidden: true,
  meta: {
    title: '信息确认'
  }
},
// 去付款
{
  path: "/payment",
  component: () => import("@/views/payment"),
  hidden: true,
  meta: {
    title: '去付款'
  },
},
// 交易结果
{
  path: "/payResult",
  name: "payResult",
  component: () => import("@/views/payResult"),
  hidden: true,
  meta: {
    title: '交易结果'
  }
},
// 在线支付/线下支付信息确认
{
  path: "/payInfoConfirm",
  component: () => import("@/views/payInfoConfirm"),
  hidden: true,
  meta: {
    title: '信息确认'
  }
},
// 支付等待
{
  path: "/payLoading",
  component: () => import("@/views/payLoading"),
  hidden: true,
  meta: {
    title: "微信"
  }
},
// 完善信息成功
{
  path: "/infoSuccess",
  component: () => import("@/views/infoSuccess"),
  hidden: true,
  meta: {
    title: "完善信息"
  }
},

// 添加代理信息
{
  path: "/addProxyInfo",
  component: () => import("@/views/addProxyInfo"),
  hidden: true,
  meta: {
    title: "填写信息"
  }
},
// 除了支付页面，第二个公共登录页 使用type区分跳转页面，以及功能点
{
  path: "/loginIndex",
  component: () => import("@/views/loginIndex"),
  meta: {
    title: '授权登录'
  },
  hidden: true
},
// 填写信息 新增研究生
{
  path: "/addPostgraduate",
  component: () => import("@/views/addPostgraduate"),
  hidden: true,
  meta: {
    title: "填写信息"
  }
},

// 院校信息确认
{
  path: "/collegesConfirm",
  component: () => import("@/views/collegesConfirm"),
  hidden: true,
  meta: {
    title: "院校信息确认"
  }
},

//上课意愿收集
{
  path: "/willingness",
  component: () => import("@/views/willingness"),
  hidden: true,
  meta: {
    title: '消息'
  }
},
//书籍勘误反馈
{
  path: "/bf",
  component: () => import("@/views/bookFeedback/bookFeedbackindex"),
  hidden: true,
  meta: {
    title: ''
  }
},
//书籍勘误反馈
{
  path: "/bf",
  component: () => import("@/views/bookFeedback/bookFeedbackindex"),
  hidden: true,
  meta: {
    title: ''
  }
},
//书籍勘误反馈表单
{
  path: "/bform",
  component: () => import("@/views/bookFeedback/bookFeedbackform"),
  hidden: true,
  meta: {
    title: '书籍建议或错误反馈'
  }
},
//咨询码
{
  path: "/consultationCode",
  component: () => import("@/views/consultationCode/index"),
  hidden: true,
  meta: {
    title: '咨询信息'
  }
},

// 咨询报告
{
  path: "/previewReport",
  component: () => import("@/views/previewReport"),
  hidden: true,
  meta: {
    title: '咨询报告'
  }
},
// 咨询报告
{
  path: "/Logistics",
  component: () => import("@/views/Logistics"),
  hidden: true,
  meta: {
    title: '物流信息'
  }
},


// 素材预览
{
  path: "/materialPreview",
  component: () => import("@/views/materialPreview"),
  hidden: true,
  meta: {
    title: '预览文件'
  }
},

// 问卷调查PC端
{
  path: "/PcQuestionsNew",
  component: () => import("@/views/PcQuestionsNew/index"),
  meta: {
    title: '聚创教育集团'
  },
  hidden: true
},

{
  path: '/503',
  component: () => import('@/views/error-page-503'),
  meta: {
    title: '503'
  },
},

// envError
{
  path: "/willingness",
  component: () => import("@/views/willingness"),
  hidden: true,
  meta: {
    title: '消息'
  }
},
{
  path: "/systemMainten",
  component: () => import("@/views/systemMainten"),
  hidden: true,
  meta: {
    title: "系统维护"
  }
},
{
  path: '/503',
  component: () => import('@/views/error-page-503'),
  meta: {
    title: '503'
  },
  hidden: true
},
{
  path: "*",
  redirect: "/404",
  hidden: true
}
];

const router = new Router({
  // mode: "history",
  // scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});

// 路由白名单
// const whitePage = ['/', '/home', '/dingpreIndex', '/t', '/td', '/industrial', '/interviewRegister', '/contractSignSucc', '/activityWriteInfo', '/mobileQuestions', '/privacyPolicy', '/autoLogin']
// 路由红名单（在线支付专用）
const redPage = ['/bf', '/bform', '/roleCheck', '/infoConfirm', '/transitStation', '/findHelp', '/makeCode', '/paymentCode', '/orderInfo', '/orderNull', '/aheadInfo', '/payment', '/payResult', '/booksConfirm', '/stayPayConfirm', '/payInfoConfirm', '/infoSuccess', '/classRegistration', '/envError']
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (redPage.includes(to.path)) {
    const obj = parseQueryString(window.location.href)
    if (obj && obj.jump && ['receipt', 'stayReceipt'].includes(obj.jump)) next()
    else envIsWxorAlipayNext(to.path, next)
  } else {
    next()
  }
})


function envIsWxorAlipayNext(path, next) {
  if (path !== "/envError") {
    if (isWeixn() || isAlipay()) {
      next()
    } else {
      next("/envError")
    }
  } else {
    next()
  }
}


export default router